module.exports = __webpack_public_path__ + "static/media/  (34).b005d965.jpg";